import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import RelationalField from "./RelationalField";
import { manyToManyDescriptor } from "../descriptors";
import { m2mName, m2mToFieldName, m2mFromFieldName } from "../utils";
/**
 * @memberof module:fields
 */

export var ManyToMany = /*#__PURE__*/function (_RelationalField) {
  _inheritsLoose(ManyToMany, _RelationalField);

  function ManyToMany() {
    return _RelationalField.apply(this, arguments) || this;
  }

  var _proto = ManyToMany.prototype;

  _proto.getDefault = function getDefault() {
    return [];
  };

  _proto.getThroughModelName = function getThroughModelName(fieldName, model) {
    return this.through || m2mName(model.modelName, fieldName);
  };

  _proto.createForwardsDescriptor = function createForwardsDescriptor(fieldName, model, toModel, throughModel) {
    return manyToManyDescriptor(model.modelName, toModel.modelName, throughModel.modelName, this.getThroughFields(fieldName, model, toModel, throughModel), false);
  };

  _proto.createBackwardsDescriptor = function createBackwardsDescriptor(fieldName, model, toModel, throughModel) {
    return manyToManyDescriptor(model.modelName, toModel.modelName, throughModel.modelName, this.getThroughFields(fieldName, model, toModel, throughModel), true);
  };

  _proto.createBackwardsVirtualField = function createBackwardsVirtualField(fieldName, model, toModel, throughModel) {
    var ThisField = this.getClass();
    return new ThisField({
      to: model.modelName,
      relatedName: fieldName,
      through: throughModel.modelName,
      throughFields: this.getThroughFields(fieldName, model, toModel, throughModel)
    });
  };

  _proto.createForwardsVirtualField = function createForwardsVirtualField(fieldName, model, toModel, throughModel) {
    var ThisField = this.getClass();
    return new ThisField({
      to: toModel.modelName,
      relatedName: fieldName,
      through: this.through,
      throughFields: this.getThroughFields(fieldName, model, toModel, throughModel),
      as: this.as
    });
  };

  _proto.getThroughFields = function getThroughFields(fieldName, model, toModel, throughModel) {
    if (this.throughFields) {
      var _this$throughFields = _slicedToArray(this.throughFields, 2),
          fieldAName = _this$throughFields[0],
          fieldBName = _this$throughFields[1];

      var fieldA = throughModel.fields[fieldAName];
      return {
        to: fieldA.references(toModel) ? fieldAName : fieldBName,
        from: fieldA.references(toModel) ? fieldBName : fieldAName
      };
    }

    if (model.modelName === toModel.modelName) {
      /**
       * we have no way of determining the relationship's
       * direction here, so we need to assume that the user
       * did not use a custom through model
       * see ORM#registerManyToManyModelsFor
       */
      return {
        to: m2mToFieldName(toModel.modelName),
        from: m2mFromFieldName(model.modelName)
      };
    }
    /**
     * determine which field references which model
     * and infer the directions from that
     */


    var throughModelFieldReferencing = function throughModelFieldReferencing(otherModel) {
      return Object.keys(throughModel.fields).find(function (someFieldName) {
        return throughModel.fields[someFieldName].references(otherModel);
      });
    };

    return {
      to: throughModelFieldReferencing(toModel),
      from: throughModelFieldReferencing(model)
    };
  };

  _createClass(ManyToMany, [{
    key: "installsForwardsVirtualField",
    get: function get() {
      return true;
    }
  }]);

  return ManyToMany;
}(RelationalField);
export default ManyToMany;